export default "__VITE_ASSET__RmRAQLj0__"